import { DASHBOARD_REFETCH_INTERVAL } from '@experiment-management-shared/utils/EMView';
import { useEffect, useState } from 'react';
import { RefetchInterval } from '@shared/types';

type UseDashboardRefetchIntervalOpts = {
  isAutoRefreshEnabled: boolean;
};
const useDashboardRefetchInterval = ({
  isAutoRefreshEnabled
}: UseDashboardRefetchIntervalOpts) => {
  const [refetchInterval, setRefetchInterval] = useState<RefetchInterval>(
    false
  );

  useEffect(() => {
    setRefetchInterval(
      isAutoRefreshEnabled ? DASHBOARD_REFETCH_INTERVAL : false
    );
  }, [isAutoRefreshEnabled]);

  return refetchInterval;
};

export default useDashboardRefetchInterval;
